import React from "react"
import { css } from "@emotion/core"
import { graphql, useStaticQuery } from "gatsby"
import Img from "gatsby-image"

const Service = props => {
  const serviceImgName = props.service.logo

  const { allImageContent } = useStaticQuery(graphql`
    query {
      allImageContent: allImageSharp {
        edges {
          node {
            fluid(maxWidth: 300) {
              originalName
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  `)

  return (
    <div
      className="col-md"
      css={css`        
        margin: 10px;
        padding: 0px;
        margin-bottom: 40px;
        font-size: 18px;
      `}
    >
      

      <div
        css={css`
          text-align: left;
          padding: 0px 15px 20px 15px;
        `}
      >
        {(() => {
          const imageForMenu = allImageContent.edges.find(
            element => element.node.fluid.originalName === props.service.image.src
          )

          return (
            <Img
              fluid={imageForMenu.node.fluid}
              imgStyle={{ objectFit: "contain" }}
              style={{ margin: "1rem", maxHeight: "calc(50vh - 4rem)" }}
            />
          )
        })()}

    <div
        className="service-title-container"
        css={css`
          background-color: #18069c;
          padding: 10px;
        `}
      >
        <h4
          css={css`
            text-align: center;
            margin: 0px;
            color: #fff;
            font-weight: 400;
          `}
        >
          {props.service.title}
        </h4>
      </div>
        
        {props.service.description}
      </div>
    </div>
  )
}

export default Service
